<template>
  <div>
    <div class="grid-content content-margin">

      <table class="simpleRow">
        <tr>
          <td>
            <el-link :underline="false">
              <el-button size="medium" round @click="createTarget" :disabled="!isEditMode">
                <i class="iconfont">&#xe727;</i>
                {{ $t('message.新增') }}
              </el-button>
            </el-link>
          </td>
          <td>
            <span class="simpleLabel">选择分类</span>
          </td>
          <td>
            <el-select v-model="target.sceneID" placeholder="选择轮播图列表" :disabled="!isEditMode">
              <el-option v-for="(it, index) in datalist" :key="index" :label="it.name" :value="it.sceneID">
              </el-option>
            </el-select>
          </td>

        </tr>
      </table>
    </div>
    <div class="grid-content content-margin">
      <el-table ref="table" :data="filterData" stripe border style="width: 100%;">
        <el-table-column fixed label="No." type="index" width="55">
        </el-table-column>
        <el-table-column fixed width="160" :label="$t('message.操作')" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="mini" v-if="isEditMode" round type="normal" icon="el-icon-zoom-in"
                @click="editTarget2(scope.row, false)"></el-button>
              <el-button size="mini" round type="normal" icon="el-icon-edit" @click="editTarget(scope.row, true)">
              </el-button>
              <el-button size="mini" :disabled="!isEditMode" round type="normal" icon="el-icon-delete"
                @click="deletetarget(scope.row)"></el-button>
            </el-button-group>
          </template>
        </el-table-column>
        <el-table-column label="图片预览" width="150" align="center">
          <template slot-scope="scope">
            <el-popover v-if="scope.row.img != ''" placement="top-start" title="" trigger="hover">
              <img :src="'' + scope.row.img" alt="" style="max-width: 500px; max-height: 500px">
              <img slot="reference" :src="'' + scope.row.img" style="max-width: 120px; max-height: 30px">
            </el-popover>
            <span v-else>{{ $t('message.无') }}</span>
          </template>
        </el-table-column>
        <el-table-column width="400" prop="content" :label="$t('message.文字内容')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column min-width="200" sortable prop="jumpurl" :label="$t('message.跳转链接')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column sortable prop="sort" :label="$t('message.排序')" width="150">
        </el-table-column>
        <!-- 问题76 -->
        <el-table-column sortable prop="isshow" :label="$t('message.是否列表显示')" width="150">
          <template slot-scope="scope">
            <span>{{ $t(`message.${getBooleanName(scope.row.isshow)}`) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-drawer :show-close="false" :size="800" :visible.sync="showDateilDrawer" :direction="'rtl'">
      <div class="grid-content subtitle">
        <span>{{ $t('message.轮播图管理') }}</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button size="medium" round @click.native="showDateilDrawer = false;">
              <i class="iconfont">&#xe600;</i>
              {{ $t('message.返回') }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode2">
            <el-button size="medium" round @click="doSaveDetail">
              <i class="iconfont">&#xe769;</i>
              {{ $t('message.确定') }}
            </el-button>
          </el-link>
        </div>
        <el-divider></el-divider>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr>
            <td>
              <span class="simpleLabel">{{ $t('message.图片') }}</span>
            </td>
            <td>

              <!-- 图片库控件 -->
              <div :class="!isEditMode2 ? 'unsel-img-box' : 'sel-img-box'" @click="doShowResourceStore(0)">
                <i class="iconfont" v-if="!target.img">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img :src="'' + target.img" alt="" style="max-width: 500px;max-height: 500px">
                  <img slot="reference" :src="'' + target.img">
                  <el-button v-if="isEditMode2" type="danger" icon="el-icon-delete" circle
                    @click.native="target.img = '';">
                  </el-button>
                </el-popover>
              </div>

            </td>
          </tr>
          <tr v-if="target.sceneID == 6">
            <td>
              <span class="simpleLabel"> 跳转后页面图(请复制url)</span>
            </td>
            <td>

              <div :class="!isEditMode2 ? 'unsel-img-box' : 'sel-img-box'" @click="doShowResourceStore(1)">
                <i class="iconfont" v-if="!testurl">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img :src="'' + testurl" alt="" style="max-width: 500px;max-height: 500px">
                  <img slot="reference" :src="'' + testurl">
                  <el-button v-if="isEditMode2" type="danger" icon="el-icon-delete" circle @click.native="testurl = '';">
                  </el-button>
                </el-popover>
              </div>
            </td>
            <td>
              <textarea style="width:0;height:0;border:none;opeacity:0" :value="testurl" ref='ipt'></textarea>
              <el-button @click="copy">点击复制</el-button>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t('message.跳转链接') }}</span>
            </td>
            <td>
              <el-input :readonly="!isEditMode2" size="mini" class="linkTextArea" v-model="target.jumpurl" type="textarea"
                :placeholder="$t('message.请输入链接')" maxlength="2000" show-word-limit width="300px">
              </el-input>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t('message.跳转类型') }}</span>
            </td>
            <td>
              <el-select v-model="target.jumptype" :placeholder="$t('message.请选择跳转类型')" :disabled="!isEditMode2">
                <el-option v-for="(it, index) in selectarr" :key="index" :label="it.key" :value="it.value">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t('message.滚动信息内容') }}</span>
            </td>
            <td>
              <el-input size="mini" :disabled="!isEditMode2" v-model="target.content"></el-input>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t('message.跳转微信id') }}</span>
            </td>
            <td>
              <el-input size="mini" :disabled="!isEditMode2" v-model="target.jumpwxappid"></el-input>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t('message.是否显示') }}</span>
            </td>
            <td>
              <el-switch :disabled="!isEditMode2" v-model="target.isshow" :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"></el-switch>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t('message.优先级排序') }}</span>
            </td>
            <td>
              <el-input-number :min="0" :disabled="!isEditMode2" size="mini" v-model="target.sort"></el-input-number>
            </td>
          </tr>
          <tr>
            <td>{{ $t('message.验证手机号') }}</td>
            <td>
              <el-switch :disabled="!isEditMode2" v-model="target.needmobile" :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"></el-switch>
            </td>
          </tr>
          <tr>
            <td>{{ $t('message.验证注册信息') }}</td>
            <td>
              <el-switch :disabled="!isEditMode2" v-model="target.needregister" :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"></el-switch>
            </td>
          </tr>
        </table>
      </div>
    </el-drawer>
    <shade v-if="showResourceStore > 0">
      <resource-store :shadeShow="showResourceStore > 0" @onClick="onResourceStoreCallback" :appID="188">
      </resource-store>
    </shade>
  </div>
</template>

<script>
import ResourceStore from "@/components/resourceStore/resourceStore";
import commonUtil from "@/utils/commonUtil";
import {
  confirmmy
} from '@/utils/minxins'
import {
  rejecthttp,
  changeflagCLOSED
} from "@/utils/request";
import shade from "@/components/shade/shade";
import Input from '../children/input.vue';
export default {
  name: 'caroustlist',
  components: {
    ResourceStore,
    shade
  },
  data() {
    return {
      isEditMode2: false,
      testurl: '',
      isEditMode: true,
      showDateilDrawer: false,
      createmode: false,
      selectarr: [{
        key: '不跳转',
        value: 0
      }, {
        key: '外部小程序',
        value: 1
      }, {
        key: '内部页面',
        value: 2
      }, {
        key: '第三方链接',
        value: 3
      }, {
        key: '活动页',
        value: 4
      }, {
        key: '外部视频号',
        value: 5
      }],
      showResourceStore: 0,
      datalist: [{
        sceneID: 1,
        name: '首页_banner轮播图'
      }, {
        sceneID: 2,
        name: '首页_小喇叭'
      }, {
        sceneID: 3,
        name: '首页_悬浮球'
      }, {
        sceneID: 4,
        name: '首页_登录弹层'
      }],
      data: [],
      target: {
        img: '',
        isshow: 0,
        jumptype: 0,
        jumpurl: '',
        jumpwxappid: '',
        needmobile: false,
        needregister: false,
        content: '',
        sort: 0,
        sceneID: 1,
        id: null
      },
      func: null,
      imgtype: undefined
    }
  },
  computed: {
    filterData() {
      if (this.data) {
        let source = this.data.filter(
          (data) => data.sceneID == this.target.sceneID
        )
        let ret = []
        for (let i = 0; i < source.length; i++) {
          ret.push({
            ...source[i].carousel,
            sceneID: source[i].sceneID,
            id: source[i].id
          })
        }
        return ret
      } else return [];
    },
  },
  methods: {
    copy() {
      // var text = document.getElementById("text").innerHTML;
      var input = this.$refs.ipt
      console.log(input)
      input.value = this.testurl;
      input.select();//选中文本
      document.execCommand("copy");

    },
    getBooleanName(bool) {
      return commonUtil.getBooleanName(bool);
    },
    doShowResourceStore(i) {
      this.showResourceStore = 1;
      console.log(i)
      this.imgtype = i
    },
    onResourceStoreCallback(doc) {
      if (doc) {
        console.log(doc, this.imgtype)

        if (!this.imgtype) {
          this.target.img = doc.resourceID
        }
        if (this.imgtype == 1) {
          this.testurl = doc.resourceID
        }
      }
      this.showResourceStore = 0;
    },
    gettarget({
      img = '',
      isshow = 1,
      jumptype = 0,
      jumpurl = '',
      jumpwxappid = '',
      content = '',
      needmobile = false,
      needregister = false,
      sort = 0,
      id = null
    } = {}, classify) {
      this.target.img = img
      this.target.isshow = isshow == 1 ? true : false;
      this.target.jumptype = jumptype
      this.target.jumpurl = jumpurl
      this.target.jumpwxappid = jumpwxappid
      this.target.needmobile = needmobile
      this.target.needregister = needregister
      this.target.content = content
      this.target.sort = sort
      this.target.id = id
      //   this.target.sceneID=sceneID
      return () => {
        if (classify === -1) {
          // 问题描述：接口调用失败后数据push后列表会将失败的数据添加到列表中，为了接口报错时不出现该条数据，则屏蔽该方法
          //            this.data.push(this.target)
        } else {
          this.data[classify] = this.target
        }
      }
    },
    createTarget() {
      this.isEditMode = true
      this.isEditMode2 = true
      this.testurl = ''
      this.func = this.gettarget({}, -1)
      this.createmode = true
      this.showDateilDrawer = true;
    },
    doSaveDetail() {
      this.showDateilDrawer = false;
      this.func()
      this.addinfo()
    },
    editTarget(R) {
      this.isEditMode2 = true
      let index = 1
      this.createmode = false
      this.func = this.gettarget(R, index)
      this.showDateilDrawer = true;
    },
    // 问题42
    editTarget2(R) {
      console.log('editTarget2');
      this.isEditMode2 = false
      let index = 1
      this.createmode = false
      this.func = this.gettarget(R, index)
      this.showDateilDrawer = true;
    },
    getlist() {
      rejecthttp(true, "get", "/manage/banner/getbannerlist?appid=188", {}, this, (doc) => {
        changeflagCLOSED(doc, 0, this);
        if (doc.data.Code == "MSGKEY_OK") {
          console.log(doc, '调用了')
          this.data = doc.data.data
        }
      });
    },
    addinfo() {
      let body = {
        appID: 188,
        carousel: {
          "img": this.target.img,
          "isshow": this.target.isshow ? 1 : 0,
          "jumptype": this.target.jumptype,
          "jumpurl": this.target.jumpurl,
          "jumpwxappid": this.target.jumpwxappid,
          "needmobile": this.target.needmobile,
          "needregister": this.target.needregister,
          "content": this.target.content,
          "sort": this.target.sort
        },
        sceneID: this.target.sceneID,
        id: this.target.id
      }
      let url = this.createmode ? '/manage/banner/addbannerinfo' : '/manage/banner/updatebannerinfo'
      rejecthttp(true, "post", url, body, this, (doc) => {
        changeflagCLOSED(doc, 1, this);
        if (doc.data.Code == "MSGKEY_OK") {
          // console.log(doc)
          // this.data = doc.data.data
          this.getlist()
        }
      });
    },
    deletetarget(r) {
      confirmmy(this, {
        title: '是否删除',
        contitle: '删除',
        cancletitle: '已取消',
        conback: () => {
          rejecthttp(true, "post", "/manage/banner/deletebannerinfo?id=" + r.id, {}, this, (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
              this.getlist()
            }
          });
        },
      })
    }
  },
  mounted() {
    this.getlist()
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/caroustlist/caroustlist.vue